import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
import Button from '../../common/CustomComponents/Button'
import Select from 'react-select'
import moment from 'moment'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'

class ChaletList extends React.Component {
  state = {
    data: [],
    isEditing: false,
    isPopularOrderEdit: false,
    keyword: '',
    price: '',
    facilityData: [],
    facilityList: [],
    categoryData: null,
    categoryList: [],
    packageData: null,
    packageList: [],
    from_date: '',
    to_date: '',
    isSearching: false,
    minToDate: moment().format('YYYY-MM-DD'),
    limit: 10,
    pageNumber: 0,
    totalCount: 0,
    totalPages: 0,
    disabled: false,
  }

  componentDidMount() {
    this.getFacilities()
    this.getChaletCategories()
    this.getGlobalPackageList()
    this.getData()
  }

  getData = async () => {
    this.setState({ isSearching: true, data: [] })
    axios
      .get(Constant.getAPI() + '/chalet/list-chalet', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          keyword: this.state.keyword,
          price: this.state.price,
          facilities: this.state.facilityData?.map((ele) => ele.value)?.join(','),
          category: this.state.categoryData?.value,
          package: this.state.packageData?.value,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            data: res.data.data,
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
            disabled: this.state?.pageNumber + 1 >= res?.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isSearching: false })
      })
  }

  handleStatusChange = async (id, status, isPopular) => {
    let data = { id }
    if (isPopular) {
      data.is_popular = status
    } else {
      data.is_active = status
    }
    await axios
      .put(Constant.getAPI() + '/chalet/update-chalet-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.getData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      if (this.state.from_date) {
        this.setState({ minToDate: moment(this.state.from_date, 'YYYY-MM-DD').add(1, 'd').format('YYYY-MM-DD') })
      }
    })
  }

  onEdit = (selectedId, order, type) => {
    if (type == 'popular') {
      this.setState({ isPopularOrderEdit: true, selectedId, popular_choice_order: order, isEditing: false })
    } else {
      this.setState({ isEditing: true, selectedId, order, isPopularOrderEdit: false })
    }
  }

  onChangeSort = (selectedId, type) => {
    var data = {
      id: selectedId,
    }

    this.setState({ isPopularOrderEdit: false, isEditing: false })

    if (type == 'popular') {
      data.popular_choice_order = parseInt(this.state.popular_choice_order)
      data.order_type = 'popular'
    } else {
      data.order_no = parseInt(this.state.order_no)
    }

    axios
      .put(Constant.getAPI() + '/chalet/update-chalet-order', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.getData()
      })
      .catch(() => {})
  }

  // onPushClick = (id) => {
  //   let dataItem = this.state.data.find((item) => item.id == id)

  //   Swal.fire({
  //     title: 'Are you sure to send the notification regarding this item?',
  //     showDenyButton: true,
  //     showCancelButton: true,
  //     confirmButtonText: `Yes`,
  //     denyButtonText: `No`,
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       await axios
  //         .post(
  //           Constant.getAPI() + '/admin/send-pushwoosh',
  //           {
  //             type: 'CH',
  //             target_id: id,
  //             name_en: dataItem.name_en,
  //             name_ar: dataItem.name_ar,
  //             selected_country: localStorage.getItem('countryShortName') || 'KWT',
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
  //               country_short_name: `${localStorage.getItem('countryShortName')}`,
  //             },
  //           }
  //         )
  //         .then((res) => {
  //           if (res.status === 200) {
  //             Swal.fire('Notification Sent !', '', 'success')
  //           }
  //         })
  //         .catch((err) => {
  //           if (err?.response?.status === 401) {
  //             Constant.getAuthLogout()
  //           } else {
  //             Swal.fire({
  //               title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
  //               icon: 'error',
  //               text: '',
  //               type: 'error',
  //               confirmButtonColor: '#3085d6',
  //               cancelButtonColor: '#d33',
  //               confirmButtonText: 'Ok',
  //             })
  //           }
  //         })
  //     }
  //   })
  // }

  getFacilities = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/get-facilities/chalet`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            facilityList: res?.data?.data?.map((ele) => {
              return { label: `${ele.name_en}/${ele.name_ar}`, value: ele.id }
            }),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getChaletCategories = async () => {
    await axios
      .get(Constant.getAPI() + `/chalet/list-chalet-category`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            categoryList: res.data.data?.map((ele) => {
              return { label: `${ele.name_en}/${ele.name_ar}`, value: ele.id }
            }),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getGlobalPackageList = async () => {
    await axios
      .get(Constant.getAPI() + `/chalet/get-chalet-global-packages`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            packageList: res.data.data?.map((ele) => {
              return { label: `${ele.name_en}/${ele.name_ar}`, value: ele.id }
            }),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          this.showErrorAlert(err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message)
        }
      })
  }

  handleClear = () => {
    this.setState({ facilityData: [] })
  }

  handleCategoryClear = () => {
    this.setState({ categoryData: {} })
  }

  handlePackageClear = () => {
    this.setState({ packageData: {} })
  }

  handleCategoryChange = (event) => {
    this.setState({
      categoryData: event,
    })
  }

  handlePackageChange = (event) => {
    this.setState({
      packageData: event,
    })
  }

  handleFacilityChange = (event) => {
    this.setState({
      facilityData: event,
    })
  }

  clearFilters = () => {
    this.setState(
      {
        facilityData: [],
        categoryData: null,
        packageData: null,
        from_date: '',
        to_date: '',
        keyword: '',
        price: '',
        limit: 10,
        pageNumber: 0,
        data: [],
      },
      () => {
        this.getData()
      }
    )
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.getData()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.getData()
      }
    )
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'img',
        label: 'Chalet Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (img) => {
            return (
              <div>
                {img !== null ? (
                  <div>
                    {img?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            img !== undefined && img !== null && img !== {}
                              ? Constant.getImage() + img
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          img !== undefined && img !== null && img !== {}
                            ? Constant.getImage() + img
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                        onError={(event) => {
                          event.currentTarget.src = './assets/images/no_image.png'
                        }}
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      img !== undefined && img !== null && img !== {}
                        ? Constant.getImage() + img
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'name_en',
        label: 'Name in English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'name_ar',
        label: 'Name in Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'order_no',
        label: 'Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isEditing ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="order_no"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.order_no}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isEditing ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeSort.bind(this, id)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order, '')}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order, '')}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'popular_choice_order',
        label: 'Popular Choice Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div className="form-group ">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isPopularOrderEdit ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="popular_choice_order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.popular_choice_order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isPopularOrderEdit ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeSort.bind(this, id, 'popular')}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order, 'popular')}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order, 'popular')}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div>
                <Toggle
                  id={id}
                  checked={isActive}
                  value={isActive + ''}
                  onChange={this.handleStatusChange.bind(this, id, !isActive, false)}
                />
              </div>
            )
          },
        },
      },
      {
        name: 'is_popular',
        label: 'Is Popular',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (isPopular, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div>
                <Toggle
                  id={id}
                  checked={isPopular}
                  value={isPopular + ''}
                  onChange={this.handleStatusChange.bind(this, id, !isPopular, true)}
                />
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div style={{ display: 'flex' }}>
                <Link
                  to={`/chalet-details/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View Chalet Details "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
                {/* <span
                  onClick={this.onPushClick.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Send Push"
                  style={{ cursor: 'pointer' }}
                >
                  <i className="f-20 icofont icofont-notification text-warning"></i>{' '}
                </span> */}
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      search: true,
      filter: true,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      selectableRows: 'none',
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => this.getData()
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => this.getData()
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? <Loader open={this.state.isSearching} /> : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Chalet List</h4>
                    </div>
                  </div>
                  <Button
                    component={Link}
                    variant="outlined"
                    color="primary"
                    className="f-right ml-1"
                    to="/chalet-master/add"
                  >
                    <i className="icofont icofont-plus m-r-5"></i> Add Chalet
                  </Button>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Chalet List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Search</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              id="keyword"
                              className="form-control"
                              value={this.state.keyword}
                              name="keyword"
                              placeholder="Name | Description | Owner"
                              onChange={this.onSearch}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Price search</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              id="price"
                              className="form-control"
                              value={this.state.price}
                              name="price"
                              placeholder="Price"
                              // onKeyPress={this.handleKeyPress}
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                      </div> */}
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Facility</label>
                          <div className="col-sm-9">
                            <Select
                              name="facilityData"
                              value={this.state.facilityData}
                              onChange={this.handleFacilityChange}
                              options={this.state.facilityList}
                              isMulti={true}
                              isSearchable={true}
                              isClearable
                              onClear={this.handleClear}
                              placeholder="Select Options"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Category</label>
                          <div className="col-sm-9">
                            <Select
                              name="categoryData"
                              value={this.state.categoryData}
                              onChange={this.handleCategoryChange}
                              options={this.state.categoryList}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handleCategoryClear}
                              placeholder="Select Option"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Package</label>
                          <div className="col-sm-9">
                            <Select
                              name="packageData"
                              value={this.state.packageData}
                              onChange={this.handlePackageChange}
                              options={this.state.packageList}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handlePackageClear}
                              placeholder="Select Option"
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-4"></div> */}
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">From Date</label>
                          <div className="col-md-9">
                            <input
                              type="date"
                              min={moment().format('YYYY-MM-DD')}
                              id="from_date"
                              className="form-control"
                              value={this.state.from_date}
                              name="from_date"
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">To Date</label>
                          <div className="col-md-9">
                            <input
                              type="date"
                              min={this.state.minToDate}
                              id="to_date"
                              className="form-control"
                              value={this.state.to_date}
                              name="to_date"
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-4"></div> */}
                      <div className="col-md-4">
                        <div className="form-group row">
                          <div className="text-left col">
                            <Button
                              onClick={this.getData}
                              disabled={this.state.isSearching}
                            >
                              {this.state.isSearching ? 'Searching...' : 'Search'}
                            </Button>
                            <Button
                              variant={'outlined'}
                              onClick={this.clearFilters}
                            >
                              Clear
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body"></div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Chalet List'}
                          className="table-responsive"
                          data={this.state.data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ChaletList
